import { MemberService } from './../../Services/member.service';
import { Component, OnInit } from '@angular/core';
import { ActivityService } from '../../Services/activity.service';
import { SubscriptionService } from '../../Services/subscription.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { AuthService } from '../../Services/auth.service';
import { VolunteerSubsriptionService } from '../../Services/volunteerSubscription.service';


@Component({
  selector: 'app-activity-tracker-form',
  template: require('./activity-tracker-form.component.html'),
  styles: [require('./activity-tracker-form.component.css')]
})
export class ActivityTrackerFormComponent implements OnInit {
  activity: any = {
    id: 0,
    activityName: "",
    date: "",
    activityKindId: 0,
    activityMembers: []
  }
  members: any[] = [];
  selectedMembersCount: number = 0;
  kinds: any[] = [];

  firstnames: any[] = [];
  lastnames: any[] = [];

  selectedDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  nameSearchString: string = '';
  searched_members: any[] = [];


  selected_members:any[] = [];
  showOnlySelected: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private activityService: ActivityService,
    private memberService: MemberService,
    private subscriptionService: SubscriptionService,
    private volunteerSubscriptionService: VolunteerSubsriptionService,
    private auth:AuthService) {

    route.params.subscribe(p => {
      if (p['id'])
        this.activity.id = +p['id'];
      else
        this.activity.id = 0;
    });

    // this.today();
  }

  ngOnInit() {
    if (this.activity.id > 0) {

      this.activityService.getActivity(this.activity.id).subscribe(
        ac => {
          if (ac.status == 200) {
            this.activity = ac.value;
            this.activity.activityMembers.forEach( (e:any) => {
              this.selected_members.push(e.member.id);
            });
            var d = new Date(this.activity.date);
            this.selectedDate = {
              jsdate: d,
              date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
            };     

          }
        }, err => {
          if (err.status == 404)
            this.router.navigate(['/home']);
        }
      );
    }
    this.activityService.getActivityKinds().subscribe(ak => {
      this.kinds = ak;
    });
  }

  ShowActivity(){
    console.log(this.activity);
    
  }


  // today() {
  //   // console.log('Vandaag');
  //   // console.log(this.courseRidden.date);
  //   var today = new Date();
  //   var dd = today.getDate();
  //   var mm = today.getMonth() + 1; //January is 0!
  //   var yyyy = today.getFullYear();
  //   var d: string = '';
  //   var m: string = '';

  //   if (dd < 10) {
  //     d = '0' + dd.toString()
  //   }
  //   else {
  //     d = dd.toString();
  //   }

  //   if (mm < 10) {
  //     m = '0' + mm.toString()
  //   }
  //   else {
  //     m = mm.toString();
  //   }

  //   var date = yyyy + '-' + m + '-' + d + "T00:00:00";

  //   this.activity.date = date

  //   // console.log(this.courseRidden.date);
  // }

  submit() {
    var memberIds: number[] = []

    this.activity.activityMembers.forEach((item: any) => {
      memberIds.push(item.memberId)
    });

    // console.log("Submit");
    console.log("this.activity:", this.activity);
    
    if (this.activity.id) {
      console.log("");
      
      var objectToSend = {
        "id": this.activity.id,
        "ActivityName": this.activity.activityName,
        "Date": new Date(Date.UTC(this.selectedDate.date.year, this.selectedDate.date.month - 1, this.selectedDate.date.day)),
        "ActivityKindId": this.activity.activityKindId,
        "ActivityMembers": memberIds
      }
      // console.log("Object to send: ");
      // console.log(objectToSend);
      this.activityService.update(objectToSend.id, objectToSend).subscribe(x => {
        // console.log(x);
        this.router.navigate(["/activity/list"]);
      });
    }
    else {
      var newObjectToSend = {
        "ActivityName": this.activity.activityName,
        "Date": new Date(Date.UTC(this.selectedDate.date.year, this.selectedDate.date.month - 1, this.selectedDate.date.day)),
        "ActivityKindId": this.activity.activityKindId,
        "ActivityMembers": memberIds
      }
      console.log(newObjectToSend)
      this.activityService.create(newObjectToSend).subscribe(x => {
        console.log(x);
        this.router.navigate(["/activity/list"])
      })
    }
  }

  delete(id: number) {
    Swal.fire({
            title: 'Ben je zeker?',
            text: "Ben je zeker dat je deze activiteit wil verwijderen?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Jep',
            cancelButtonText: 'Nope'
          }).then((result) => {
            if (result.value) {
              this.activityService.delete(id).subscribe(x => {
                this.router.navigate(["/activity/list"]);
              })
            }
          });
  }

  loadAllMembers() {
    // console.log("loading all members");
    this.memberService.getMembers().subscribe(x => {
    this.members = x;
    // console.log(this.members);
    this.selectedMembersCount =  this.selected_members.length;
    this.searched_members = this.members
  });
  }

  addMember() {
    // var checks = document.getElementsByName("userchecks");
    // var addedMembers: any = [];

    // for (let i = 0; i < checks.length; i++) {
    //   const element = (<HTMLInputElement>checks[i]);
    //   if (element.checked === true) {

    //     var index = this.activity.activityMembers.findIndex((m: any) => m.memberId == element.value);

    //     // console.log(index);
    //     if (index === -1) {
    //       addedMembers.push(element.value)
    //     }

    //   }
    // }
    this.activity.activityMembers = [];
    this.selected_members.forEach((id: number) => {
      var member = this.members.find(m => m.id == id);
      var activityMember = {
        "activityId": this.activity.id,
        "member": member,
        "memberId": member.id
      }
      this.activity.activityMembers.push(activityMember);
    });
  }

  checkboxClicked(id: any) {
    // console.log("checkbox clicked:")
    // console.log(id);
    if (this.selected_members.find( x => x == id)){
      const index = this.selected_members.indexOf(id, 0);
      if (index > -1) {
        this.selected_members.splice(index, 1);
      }

    }else{
      this.selected_members.push(id);
    }
    // console.log(this.selected_members);
    this.selectedMembersCount =  this.selected_members.length
    // var count = 0;
    // var checks = document.getElementsByName("userchecks");
    // for (let i = 0; i < checks.length; i++) {
    //   const element = (<HTMLInputElement>checks[i]);
    //   if (element.checked === true) count++
    // }
    // // console.log("geselecteerden: " + count);
    // this.selectedMembers = count;
  }

  removeMember(id: number) {
    // console.log("remove Member: " + id);
    var index = this.activity.activityMembers.findIndex((m: any) => m.memberId === id);
    this.activity.activityMembers.splice(index, 1);
  }

  searchName(){
    // console.log('search: '+ this.nameSearchString);
    // console.log(this.members);
    if (this.nameSearchString.length > 0){
      let f = this.members.filter( (a:any)=> a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      let l = this.members.filter( (a:any) => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      if (f.length > 0) {
        this.searched_members = f
      }
      if (l.length > 0) {
        this.searched_members = this.searched_members.concat(l)
      }

      // console.log("Searched members: ");
      // this.searched_members = this.firstnames.concat(this.lastnames);
      // console.log(this.searched_members);
        
      }else{
        this.searched_members = this.members
      }
  }

  isSelected(id: any){
    if (this.selected_members.find( x => x == id)){
      return true;
    }
    else{
      return false
    }
  }

  clearSearch(){
    this.nameSearchString = '';
    this.searchName();
  }

  showRow(id: any){
    if (this.showOnlySelected && this.isSelected(id)) return true;
    else if (!this.showOnlySelected) return true;
  }



  ImportMembers(){
    // console.log("import Activities members");
    // console.log("activity.id: "+this.activity.id);
    this.subscriptionService.getAllSubscriptions().subscribe((res: any) => {
      // console.log(res);

      //   <select id="activityKind" class="form-control" [(ngModel)]="activity.activityKindId" name="activityKindId" required>
      //   <option value=""> Selecteer een type </option>
      //   <option *ngFor="let ak of kinds" value="{{ ak.id }}">{{ ak.name }}</option>
      // </select>

      var html = `<select id="SubscriptionSelect" class="form-control"  name="SubscriptionSelectId" required>
                <option value="-1"> Selecteer een een activiteit </option>          
      `;

      res.forEach((x: any) => {
        html += `<option value="${x.id}"> ${x.subject}</option>          `;
      });

      html += `</select>`;

      Swal.fire({
        title: "Selecteer een evenement?",
        html: html,
        type: "question",
        width: "600px",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        cancelButtonText: "Nope",
        preConfirm: function(result) {
          if (result) {
            // TODO: WorkAround HtmlElement as String
            // var activityId = parseInt( ($('#SubscriptionSelect').val() as string));
            // var activityId = parseInt(x);
            // var activityId =  parseInt( ($('#SubscriptionSelect').val()as HTMLInputElement).value);
            var activityId = parseInt( String($('#SubscriptionSelect').val()) )
            
            return { activityId: activityId };
          }
        },
      }).then((result) => {
        if (typeof(result.value) !== 'undefined'){
            if (result){
              this.subscriptionService.GetCurrentMembersForSubscription(result.value.activityId).subscribe( (res:any) =>{
                // console.log("All members: ",res);
                res.forEach( (x:any) => {
                  var activityMember = {
                    "activityId": this.activity.id,
                    "member": x.member,
                    "memberId": x.member.id
                  }
                  
                  var loc = this.activity.activityMembers.findIndex((i:any) => i.memberId === activityMember.memberId)
                  if (loc > -1){              
                    this.activity.activityMembers.splice(loc,1)
                  }
                  this.activity.activityMembers.push(activityMember);
                });          
                
              })
            }
        }
      });
    });
    
  }

  ImportVolunteers(){
    // console.log("import Volonteers");
    // console.log("activity.id: "+this.activity.id);
    
    this.volunteerSubscriptionService.getAllVolunteerActivities().subscribe((res: any) => {
      console.log(res);

      //   <select id="activityKind" class="form-control" [(ngModel)]="activity.activityKindId" name="activityKindId" required>
      //   <option value=""> Selecteer een type </option>
      //   <option *ngFor="let ak of kinds" value="{{ ak.id }}">{{ ak.name }}</option>
      // </select>

      var html = `<select id="VolunteerSubscriptionSelect" class="form-control"  name="VolunteerSubscriptionSelectId" required>
                <option value="-1"> Selecteer een een activiteit </option>          
      `;

      if (res.status == 200){
        res.value.forEach((x: any) => {
            html += `<option value="${x.id}"> ${x.subject}</option>          `;
        });

        html += `</select>`;

        Swal.fire({
          title: "Selecteer een evenement?",
          html: html,
          type: "question",
          width: "600px",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          cancelButtonText: "Nope",
          preConfirm: function(result) {
            if (result) {
              // TODO: WorkAround HtmlElement as String
              // var activityId = parseInt( ($('#SubscriptionSelect').val() as string));
              // var activityId = parseInt(x);
              // var activityId =  parseInt( ($('#SubscriptionSelect').val()as HTMLInputElement).value);
              var activityId = parseInt( String($('#VolunteerSubscriptionSelect').val()) )
              
              return { activityId: activityId };
            }
          },
        }).then((result) => {
          if (typeof(result.value) !== 'undefined'){
              if (result){
                this.volunteerSubscriptionService.getAllMemberVolunteerSubscriptionsForActivity(result.value.activityId).subscribe( (res:any) =>{
                  // console.log("All members: ",res);

                  if (res.status == 200){
                    res.value.forEach( (x:any) => {
                      // console.log(x);
                      
                      var activityMember = {
                        // "activityId": this.activity.id,
                        "member": x.member,
                        "memberId": x.member.id
                      }
                      
                      var loc = this.activity.activityMembers.findIndex((i:any) => i.memberId === activityMember.memberId)
                      if (loc > -1){              
                        this.activity.activityMembers.splice(loc,1)
                      }
                      this.activity.activityMembers.push(activityMember);
                    });          
                  }
                })
              }
          }
        });  
        }

      
    });

    
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/activity-tracker-form/activity-tracker-form.component.ts